'use client'

import { ColorPalette } from '@carbon/icons-react'
import SelectPrimitive, {
  SelectItem as SelectItemPrimitve,
} from 'app/_components/Select'
import { useRef } from 'react'
import { twMerge } from 'tailwind-merge'

const defaultColorOptions = {
  Weiß: '#ffffff',
  Pink: '#f27fb1',
  Grau: '#d4d7dd',
  Grün: '#a0e100',
  Gelb: '#ffffc1',
  Blau: '#8392ca',
  Custom: 'custom',
}

type ColorSelectProps = {
  value?: string
  onChange: (value: string) => void
  className?: string
  colorOptions?: Record<string, string>
}

export function ColorSelect({
  value,
  onChange,
  className,
  colorOptions = defaultColorOptions,
}: ColorSelectProps) {
  const colorInputRef = useRef<HTMLInputElement>(null)

  function handleColorChange(value: string) {
    if (value === 'custom') {
      colorInputRef.current?.click()
    } else {
      onChange(value)
    }
  }

  function handleCustomColorChange(event: React.ChangeEvent<HTMLInputElement>) {
    onChange(event.target.value)
  }

  return (
    <div className={className}>
      <SelectPrimitive
        placeholder="Textfarbe"
        label="Textfarbe"
        onValueChange={handleColorChange}
        value={value}
        Trigger={(props) => (
          <SelectPrimitive.Trigger
            className={twMerge('button hover:bg-gray-20', props.className)}
            title={'Farbe ändern'}
          >
            <SelectPrimitive.Icon className="h-4 w-4 text-black">
              <ColorPalette />
            </SelectPrimitive.Icon>
          </SelectPrimitive.Trigger>
        )}
      >
        {Object.entries(colorOptions ?? {}).map(([key, value]) => {
          return (
            <SelectItemPrimitve value={value} key={key}>
              <div className="flex items-center gap-2">
                <div
                  className="h-4 w-4 border border-gray-300"
                  style={{
                    backgroundColor: value === 'custom' ? value : value,
                  }}
                />
                {key}
              </div>
            </SelectItemPrimitve>
          )
        })}
      </SelectPrimitive>
      <input
        ref={colorInputRef}
        type="color"
        defaultValue={value}
        hidden
        onChange={handleCustomColorChange}
      />
    </div>
  )
}
